<template>
  <svg width="40" height="40" viewBox="0 0 137 137" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0L23.6728 0.000217587L46.3382 0L64.4705 18.0002H18.1323V64.0002L0 46.0002V0Z" fill="black" />
    <path d="M0 137L0.000219186 113.5L0 91L18.1325 73V119H64.4707L46.3384 137H0Z" fill="black" />
    <path d="M137 137L113.327 137L90.6616 137L72.5293 119L118.867 119L118.867 73L137 91L137 137Z" fill="black" />
    <path d="M137 0L137 23.5L137 46L118.867 64L118.867 18L72.5293 18L90.6616 -2.01073e-06L137 0Z" fill="black" />
  </svg>
</template>
